export default "__VITE_ASSET__C9oHNKe1__"